import React, { Component } from "react";
import { View, ScrollView, SafeAreaView, TouchableOpacity } from "react-native";
import { connect } from "react-redux";
import { getServerResponse, phoneNumberFormate } from "../../../functions";
import styles from "../../../styles";
import { changeUserProfile } from "../../../action";
import { global, action, colors } from "../../../const";
import { PrimaryCaption, PrimaryTitle, LinkIndigo } from "../../../components/labels";
import { TextInput, Button } from "../../../components/form";
import SuccessDialog from "../../../components/modal/SuccessDialog";
import Header from "../../../components/Header";
import localize from "../../../localize";

class UpdatePhone extends Component {

    static navigationOptions = () => {
        return {
            title: localize.Change_Phone
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            phone: '',
            newPhone: '',
            errorMessage: localize.Invalid_letters_detected_in_phone_number,
            isVisible: false
        }
    }

    onPhoneChange = async (phone) => {
        let errorMessage = this.state.errorMessage;
        phone = phone.replace(/-/g, '');
        phone = phoneNumberFormate(phone)
        this.setState({ newPhone: phone });
        try {
            phone = phone.replace(/-/g, '');
            const response = await getServerResponse({ cmd: "WcnUser1.checkPhone", phone });
            if (response === 200) errorMessage = null;
            else errorMessage = localize.Invalid_letters_detected_in_phone_number
        } catch (error) {
            console.warn(error)
        }
        return this.setState({ errorMessage });
    }

    onUpdatePhone = async () => {
        let { newPhone, errorMessage } = this.state;
        if (errorMessage !== null) return
        this.props.isLoading(true);
        newPhone = newPhone.replace(/-/g, '');
        let res = await this.props.changeUserProfile({ cmd: "WcnUser1.changePhoneNumber", number: newPhone })
        this.props.isLoading(false);
        if (res === 200 || res === "200") {
            setTimeout(() => {
                this.setState({ isVisible: true });
            }, 350);
        }
    }

    render() {
        const { newPhone, errorMessage, isVisible } = this.state;
        const { phone_number } = this.props.userInfo;

        return (
            <SafeAreaView style={styles.container}>
                <Header title={localize.Change_Phone} goBack={() => this.props.history.goBack()} hidden={global.isNative} />
                <ScrollView style={!global.isNative ? { height: this.props.height - 70 } : null} keyboardShouldPersistTaps="handled">
                    <View style={{ marginVertical: 20, marginHorizontal: 20 }}>
                        <PrimaryTitle>
                            {localize.To_set_a_new_phone_number_please_enter_your_current_phone_number_first}
                        </PrimaryTitle>
                        <View style={{ height: 30 }} />
                        <PrimaryCaption>
                            {localize.current_phone_number}
                        </PrimaryCaption>
                        <View style={{ height: 5 }} />
                        <PrimaryTitle color={colors.gray}>
                            {phone_number || ""}
                        </PrimaryTitle>
                        <View style={{ height: 30 }} />
                        <TextInput
                            title={localize.new_phone_number}
                            placeholder={localize.new_phone_number}
                            keyboardType="phone-pad"
                            value={newPhone}
                            onChangeText={this.onPhoneChange}
                            error={newPhone !== '' && errorMessage}
                            onSubmitEditing={this.onUpdatePhone}
                        />
                        <View style={{ height: 30 }} />
                        <Button
                            title={localize.change}
                            disabled={errorMessage !== null || newPhone === "" ? true : false}
                            onPress={this.onUpdatePhone}
                        />
                        <View style={{ paddingVertical: 30 }}>
                            <TouchableOpacity
                                onPress={() => global.isNative ? this.props.navigation.goBack() : this.props.history.goBack()}
                                style={{ alignSelf: "center", marginVertical: 10, marginHorizontal: 20 }}
                            >
                                <LinkIndigo>
                                    {localize.cancel}
                            </LinkIndigo>
                            </TouchableOpacity>
                        </View>
                    </View>
                </ScrollView>
                <SuccessDialog
                    isVisible={isVisible}
                    onCancel={() => this.setState({ isVisible: false, newPhone: "" })}
                    buttonTitle={localize.Ok}
                    buttonAction={() => this.setState({ isVisible: false, newPhone: "" })}
                    title={localize.Phone_number_has_been_changed}
                />
            </SafeAreaView>
        );
    }

}

const mapStateToProps = ({ setting, auth }) => {
    return {
        height: setting.height,
        userInfo: auth.userInfo,
    };
}
const mapDispatch = (dispatch) => {
    return {
        changeUserProfile: request => dispatch(changeUserProfile(request)),
        isLoading: (status) => dispatch({ type: status ? action.LOADING_DIALOG_TRUE : action.LOADING_DIALOG_FALSE }),
    }
}
export default connect(mapStateToProps, mapDispatch)(UpdatePhone);